import { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { Sheet, SheetContent, SheetTitle, SheetDescription, SheetTrigger } from './ui/sheet';
import { Button } from './ui/button';
import { contact } from '../data/portfolio';
import { ThemeToggle } from './ThemeToggle';

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { hash, pathname } = useLocation();
  const links = (prefix) => <>
    <NavLink data-testid={`${prefix}-home`} to="/" end onClick={() => { setOpen(false); if (pathname === '/' && !hash) window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }); }} className={({ isActive }) => isActive && !hash ? 'nav-link active' : 'nav-link'}>HOME</NavLink>
    <NavLink data-testid={`${prefix}-work`} to="/work" onClick={() => setOpen(false)} className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>WORK</NavLink>
    <NavLink data-testid={`${prefix}-about`} to="/about" onClick={() => setOpen(false)} className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>ABOUT</NavLink>
    <Link data-testid={`${prefix}-contact`} to="/#contact" onClick={() => setOpen(false)} className={`nav-link ${hash === '#contact' ? 'active' : ''}`}>CONTACT</Link>
  </>;
  return <header className="navbar page-inset" data-testid="navbar">
    <nav className="desktop-nav" aria-label="Main navigation">{links('nav')}</nav>
    <Link className="mobile-identity" to="/" data-testid="mobile-home">PRANJALI SAXENA<span>COMMUNICATION DESIGNER</span></Link>
    <div className="nav-right">
      <a className="nav-link resume-nav" data-testid="nav-resume" href={contact.resume} target="_blank" rel="noopener noreferrer">RESUME ↗</a>
      <ThemeToggle />
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild><Button variant="ghost" size="icon" className="mobile-menu-trigger" data-testid="mobile-menu-open" aria-label="Open navigation"><Menu size={20} /></Button></SheetTrigger>
        <SheetContent className="portfolio-sheet" data-testid="mobile-menu">
          <SheetTitle data-testid="mobile-menu-title">A little look around.</SheetTitle>
          <SheetDescription data-testid="mobile-menu-description">Pranjali Saxena · Communication Designer</SheetDescription>
          <nav aria-label="Mobile navigation">{links('mobile-nav')}
            <a data-testid="mobile-nav-resume" className="nav-link" href={contact.resume} target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)}>RESUME ↗</a>
          </nav>
          <span className="eyebrow">MADE IN INDIA. WITH A LITTLE CHAOS.</span>
        </SheetContent>
      </Sheet>
    </div>
  </header>;
};